import React, {Component} from 'react';
import styles from './layout.module.sass';
import {Route, Switch, Redirect, withRouter} from 'react-router-dom';
import Header from '../../components/Header';
import NavBar from '../../components/NavBar';
import ScrollToTop from '../../components/Scroller';
import Typography from '@material-ui/core/Typography';
import Directives from '../Directives/Directives';
import Orders from "../../screens/ordersScreen";
import BrandsScreen from "../../screens/BrandsScreen/brandsScreen";
import AddEditBrand from "../../screens/AddEditBrand/addEditBrand";
import CategoriesScreen from "../../screens/CategoriesScreen";
import ItemsScreen from "../../screens/ItemsScreen";
import AddEditItem from "../../screens/AddEditItem/addEditItem";
import AddEditCategory from "../../screens/AddEditCategory/addEditCategory";
import UsersScreen from "../../screens/UsersScreen/usersScreen";
import UsersRequestsScreen from "../../screens/UsersRequestsScreen/usersRequestsScreen";
import DealsScreen from "../../screens/DealsScreen";
import AddEditDeals from "../../screens/AddEditDeals/addEditDeals";
import PickupsScreen from "../../screens/PickupsScreen/pickupsScreen";
import AddEditPickup from "../../screens/AddEditPickup/addEditPickup";

const NotFoundContent = () => <Typography variant='h5' component='h2'> Not Found </Typography>;

class Layout extends Component<any> {

    state = {
        navOpened: true,
    };

    handleNavButton = () => {
        this.setState({navOpened: !this.state.navOpened});
    }

    render() {
        return (
            <div className={styles.mainSection}>
                <Header onNavClicked={this.handleNavButton}/>
                <div className={styles.secondarySection}>
                    <Directives dIf={this.state.navOpened}>
                        <div className={styles.navBar}>
                            <NavBar/>
                        </div>
                    </Directives>
                    <div className={styles.mainContent}>
                        <ScrollToTop {...{}}>
                            <Switch>
                                <Route exact={true} path='/orders' component={Orders}/>
                                <Route exact={true} path='/brands' component={BrandsScreen}/>
                                <Route exact={true} path='/brands/new' component={AddEditBrand}/>
                                <Route exact={true} path='/brands/:brandId/edit' component={AddEditBrand}/>
                                <Route exact={true} path='/categories' component={CategoriesScreen}/>
                                <Route exact={true} path='/categories/new' component={AddEditCategory}/>
                                <Route exact={true} path='/categories/:categoryId/edit' component={AddEditCategory}/>
                                <Route exact={true} path='/items' component={ItemsScreen}/>
                                <Route exact={true} path='/items/new' component={AddEditItem}/>
                                <Route exact={true} path='/items/:itemId/edit' component={AddEditItem}/>
                                <Route exact={true} path='/deals' component={DealsScreen}/>
                                <Route exact={true} path='/deals/new' component={AddEditDeals}/>
                                <Route exact={true} path='/deals/:dealId/edit' component={AddEditDeals}/>
                                <Route exact={true} path='/pickups' component={PickupsScreen}/>
                                <Route exact={true} path='/pickups/new' component={AddEditPickup}/>
                                <Route exact={true} path='/pickups/:pickupId/edit' component={AddEditPickup}/>
                                <Route exact={true} path='/users' component={UsersScreen}/>
                                <Route exact={true} path='/requests' component={UsersRequestsScreen}/>
                                <Redirect from='/' to='/items' />
                                <Route render={NotFoundContent}/>
                            </Switch>
                        </ScrollToTop>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Layout);
